import { useEffect, useState } from 'react'
import axios from 'axios'
import { Clapperboard, ImageIcon } from 'lucide-react'
import PageHeader from '../components/PageHeader'
import type { ShowcaseMedia, ShowcasePageData } from '../types/Showcase'

const Media = ({ media }: { media: ShowcaseMedia }) => (
  <figure className="showcase-media">
    {media.type === 'VIDEO'
      ? <video src={media.url} controls preload="metadata" aria-label={media.altText || media.caption || 'Vidéo du club'} />
      : <img src={media.url} alt={media.altText || ''} loading="lazy" />}
    {media.caption && <figcaption>{media.caption}</figcaption>}
  </figure>
)

const Showcase = () => {
  const [data, setData] = useState<ShowcasePageData | null>(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    axios.get<ShowcasePageData>('/api/showcase').then(({ data: response }) => setData(response)).catch(() => setError(true))
  }, [])

  if (error) return <div className="board-status board-status-error">Impossible de charger la présentation du club.</div>
  if (!data) return <div className="board-status">Chargement de la présentation…</div>

  return (
    <div className="space-y-8">
      <PageHeader eyebrow={data.settings.eyebrow} title={data.settings.title} description={data.settings.introduction} icon={<Clapperboard />} />
      {data.sections.length === 0 ? (
        <div className="empty-state"><ImageIcon className="mx-auto mb-4 h-10 w-10 text-emerald-600" /><h2>La présentation arrive bientôt</h2></div>
      ) : (
        <div className="showcase-sections">
          {data.sections.map((section) => (
            <section key={section.id} className={`showcase-section showcase-layout-${section.layout.toLowerCase()} showcase-tone-${section.tone.toLowerCase()}`}>
              <div className="showcase-copy"><p className="eyebrow">Taï-Jitsu Drômois</p><h2>{section.title}</h2><p>{section.content}</p></div>
              {section.media.length > 0 && <div className="showcase-gallery">{section.media.map((media) => <Media key={media.id} media={media} />)}</div>}
            </section>
          ))}
        </div>
      )}
    </div>
  )
}

export default Showcase
